module.exports = Promise;


//////////////////
// WEBPACK FOOTER
// external "Promise"
// module id = 225
// module chunks = 0